import { usePrimeVue } from 'primevue/config';

export const useCalendar = () => {
  const primeVue = usePrimeVue();

  const changeLabelCalendarToFrench = () => {
    primeVue.config.locale.dayNames = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    primeVue.config.locale.dayNamesShort = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
    primeVue.config.locale.dayNamesMin = ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
    primeVue.config.locale.monthNames = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    primeVue.config.locale.monthNamesShort = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
    primeVue.config.locale.startsWith = 'Commence par';
    primeVue.config.locale.notContains = ' Ne contient pas';
    primeVue.config.locale.contains = 'Contient';
    primeVue.config.locale.endsWith = 'Se termine par';
    primeVue.config.locale.equals = 'Égal à';
    primeVue.config.locale.notEquals = 'Différent de';
    primeVue.config.locale.dateIs = 'La date est';
    primeVue.config.locale.dateIsNot = "La date n'est pas";
    primeVue.config.locale.dateBefore = 'Avant le';
    primeVue.config.locale.dateAfter = 'Après le';
  };

  return {
    changeLabelCalendarToFrench
  };
};
